
import { useEffect, useState } from 'react'

type Breakpoints = Record<string, number>

export function useBreakpoints<T extends Breakpoints>(breakpoints: T) {

  const getInitialState = (): Record<keyof T, boolean> => {
    const result = {} as Record<keyof T, boolean>
    for (const key in breakpoints) {
      result[key as keyof T] = false
    }
    return result
  }

  const [state, setState] = useState<Record<keyof T, boolean>>(getInitialState)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)

    const handleResize = () => {
      const width = typeof window !== 'undefined' ? window.innerWidth : 0
      const newState = {} as Record<keyof T, boolean>

      for (const key in breakpoints) {
        newState[key as keyof T] = width < breakpoints[key]
      }
      setState(newState)
    }

    
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoints])


  return { ...state, mounted }
}
